document.addEventListener("DOMContentLoaded", function() {
  class YGMegaMenu extends HTMLElement {
    constructor() {
      super();
      this.tabs = null;
      this.items = null;
      this.titleTexts = null;
      this.productItems = null;
      this.tabHandlers = [];
      this.titleTextHandlers = [];
      this.handleResize = this.handleResize.bind(this);
      this.init();
    }
    init() {
      this.tabs = this.querySelectorAll('.yg-collection-tab-item');
      this.items = this.querySelectorAll('.yg-collection-products-item');
      this.titleTexts = this.querySelectorAll('.yg-collection-products-title-text');
      this.productItems = this.querySelectorAll('.yg-collection-product-item');

      // 初始化一级切换：只在没有任何 active 时才添加
      const hasActiveTab = Array.from(this.tabs).some(tab => tab.classList.contains('active'));
      const hasActiveItem = Array.from(this.items).some(item => item.classList.contains('active'));
      
      if (!hasActiveTab) {
        this.tabs[0]?.classList.add('active');
      }
      if (!hasActiveItem) {
        this.items[0]?.classList.add('active');
      }

      // 初始化二级切换：只在没有任何 active 时才添加
      const hasActiveTitle = Array.from(this.titleTexts).some(title => title.classList.contains('active'));
      const hasActiveProduct = Array.from(this.productItems).some(product => product.classList.contains('active'));
      
      if (!hasActiveTitle) {
        this.titleTexts[0]?.classList.add('active');
      }
      if (!hasActiveProduct) {
        this.productItems[0]?.classList.add('active');
      }

      if (this.tabs.length === 0 || this.items.length === 0) return;

      // 根据屏幕宽度设置事件
      this.handleResize();
      window.addEventListener('resize', this.handleResize);
    }

    // 一级切换：左侧 tab ↔ 右侧 products-item
    switchTab(index) {
      this.tabs.forEach((t, j) => t.classList.toggle('active', index === j));
      this.items.forEach((item, j) => item.classList.toggle('active', index === j));

      const activeItem = this.items[index];
      if (!activeItem) return;

      const titleTextsInItem = activeItem.querySelectorAll('.yg-collection-products-title-text');
      const titleLinksInItem = activeItem.querySelectorAll('.yg-collection-products-title-link');
      const productItemsInItem = activeItem.querySelectorAll('.yg-collection-product-item');

      if (titleTextsInItem.length > 0) {
        titleTextsInItem.forEach((title, j) => {
          title.classList.toggle('active', j === 0);
        });
      }

      if (titleLinksInItem.length > 0) {
        titleLinksInItem.forEach((link, j) => {
          link.classList.toggle('active', j === 0);
        });
      }

      if (productItemsInItem.length > 0) {
        productItemsInItem.forEach((product, j) => {
          product.classList.toggle('active', j === 0);
        });
      }
    }

    // 二级切换：右侧 title-text ↔ 右侧 product-item（只切换同一 products-item 下的）
    switchSubTab(clickedTitle) {
      // 找到点击元素的父容器 yg-collection-products-item
      const parentItem = clickedTitle.closest('.yg-collection-products-item');
      if (!parentItem) return;

      // 在父容器内找到所有的 title-texts、view-all links 和 product-items
      const titleTextsInItem = parentItem.querySelectorAll('.yg-collection-products-title-text');
      const titleLinksInItem = parentItem.querySelectorAll('.yg-collection-products-title-link');
      const productItemsInItem = parentItem.querySelectorAll('.yg-collection-product-item');

      // 找到点击元素在同一父容器内的索引
      const index = Array.from(titleTextsInItem).indexOf(clickedTitle);
      if (index === -1) return;

      // 切换同一父容器下的元素
      titleTextsInItem.forEach((title, j) => {
        title.classList.toggle('active', j === index);
      });
      titleLinksInItem.forEach((link, j) => {
        link.classList.toggle('active', j === index);
      });
      productItemsInItem.forEach((product, j) => {
        product.classList.toggle('active', j === index);
      });
    }

    handleResize() {
      const isMobile = window.innerWidth < 1150;

      // 清除现有事件监听器
      this.tabHandlers.forEach(({ tab, handler, type }) => {
        tab.removeEventListener(type, handler);
      });
      this.titleTextHandlers.forEach(({ title, handler, type }) => {
        title.removeEventListener(type, handler);
      });
      this.tabHandlers = [];
      this.titleTextHandlers = [];

      // 一级切换：左侧 tabs 事件
      this.tabs.forEach((tab, i) => {
        let handler;
        let type;

        if (isMobile) {
          type = 'click';
          handler = () => this.switchTab(i);
        } else {
          type = 'mouseenter';
          handler = () => this.switchTab(i);
        }

        tab.addEventListener(type, handler);
        this.tabHandlers.push({ tab, handler, type });
      });

      // 二级切换：右侧 title-texts 事件（始终使用点击）
      this.titleTexts.forEach((title, i) => {
        const handler = (e) => this.switchSubTab(e.currentTarget);
        title.addEventListener('click', handler);
        this.titleTextHandlers.push({ title, handler, type: 'click' });
      });
    }

    disconnectedCallback() {
      window.removeEventListener('resize', this.handleResize);
      // 清除所有事件监听器
      this.tabHandlers.forEach(({ tab, handler, type }) => {
        tab.removeEventListener(type, handler);
      });
      this.titleTextHandlers.forEach(({ title, handler, type }) => {
        title.removeEventListener(type, handler);
      });
    }
  }
  if (!window.customElements.get('yg-mega-menu')) {
    window.customElements.define('yg-mega-menu', YGMegaMenu);
  }

  class YGCollectionProducts extends HTMLElement {
    constructor() {
      super();
      this.initSwiper();
    }

    initSwiper() {
      new Swiper(this, {
        slidesPerView: 2,
        spaceBetween: 10,

      })
    }
  }

  if (!window.customElements.get('yg-collection-products')) {
    window.customElements.define('yg-collection-products', YGCollectionProducts);
  }
  
  class YGPriceButton extends HTMLElement {
    constructor() {
      super();
      this._onClick = this._onClick.bind(this);
    }

    connectedCallback() {
      this.addEventListener('click', this._onClick);
    }

    disconnectedCallback() {
      this.removeEventListener('click', this._onClick);
    }

    _onClick(e) {
      // 找到最近的 product-card 元素或包含 .product-card 的父节点
      const productCard = this.closest('product-card') || this.closest('.product-card');
      if (!productCard) return;

      const quickBuy = productCard.querySelector('.product-card__quick-buy');
      if (!quickBuy) return;

      // 优先触发显式的提交或按钮元素
      const trigger = quickBuy.querySelector('button[type="submit"], button, a, input[type="submit"]');
      if (trigger) {
        trigger.click();
      }
    }
  }

  if (!window.customElements.get('yg-price-button')) {
    window.customElements.define('yg-price-button', YGPriceButton);
  }
  // 自定义元素：<yg-product-data-list> 在悬停时滚动到最右侧，离开时回到最左侧
  class YGProductDataList extends HTMLElement {
    constructor() {
      super();
      this._onEnter = this._onEnter.bind(this);
      this._onLeave = this._onLeave.bind(this);
    }

    connectedCallback() {
      // 延迟绑定以确保样式和尺寸已计算
      if (this._ygInit) return;
      this._ygInit = true;
      this.addEventListener('mouseenter', this._onEnter);
      this.addEventListener('mouseleave', this._onLeave);
      // always ensure mask exists so it's visible even before hover
      this._ensureMask();
    }

    disconnectedCallback() {
      this.removeEventListener('mouseenter', this._onEnter);
      this.removeEventListener('mouseleave', this._onLeave);
      // remove scroll listener
      if (this._hasScrollListener && this._onScroll) {
        this.removeEventListener('scroll', this._onScroll);
        this._hasScrollListener = false;
        this._onScroll = null;
      }
      // disconnect ResizeObserver
      if (this._ro) {
        try { this._ro.disconnect(); } catch (e) {}
        this._ro = null;
      }
      // cancel any running animation
      if (this._ygScrollRaf) {
        cancelAnimationFrame(this._ygScrollRaf);
        this._ygScrollRaf = null;
      }
      // remove mask if appended inside the list or inside a list-box container
      if (this._maskEl) {
        const possibleContainer = this.closest('.yg-product-data-list-box') || this;
        if (this._maskEl.parentElement === possibleContainer) {
          try { possibleContainer.removeChild(this._maskEl); } catch (e) {}
        }
      }
      this._maskEl = null;
      this._ygInit = false;
    }

    _onEnter() {
      // 仅在内容溢出时滚动并显示遮罩逻辑
      if (this.scrollWidth <= this.clientWidth) return;
      this._ensureMask();
      this._animateScrollTo(this.scrollWidth - this.clientWidth, 700);
    }

    _onLeave() {
      this._animateScrollTo(0, 700);
    }
    
    // 动画滚动到指定位置（ms），使用 easeInOutQuad
    _animateScrollTo(targetLeft, duration = 700) {
      const startLeft = this.scrollLeft;
      const change = targetLeft - startLeft;
      const startTime = performance.now();

      const easeInOutQuad = (t) => t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t;

      const step = (now) => {
        const elapsed = now - startTime;
        const t = Math.min(1, elapsed / duration);
        const eased = easeInOutQuad(t);
        this.scrollLeft = Math.round(startLeft + change * eased);
        this._updateMaskVisibility();
        if (t < 1) {
          this._ygScrollRaf = requestAnimationFrame(step);
        } else {
          this._ygScrollRaf = null;
          this._updateMaskVisibility(true);
        }
      };

      if (this._ygScrollRaf) cancelAnimationFrame(this._ygScrollRaf);
      this._ygScrollRaf = requestAnimationFrame(step);
    }

    _ensureMask() {
      // attach mask INSIDE the nearest .yg-product-data-list-box if exists, otherwise inside this list element
      const container = this.closest('.yg-product-data-list-box') || this;
      // ensure container is positioned to allow absolute mask
      if (getComputedStyle(container).position === 'static') {
        container.style.position = 'relative';
      }

      if (!this._maskEl) {
        const mask = document.createElement('div');
        mask.className = 'yg-product-data__mask';
        mask.style.position = 'absolute';
        mask.style.right = '0';
        mask.style.width = '48px';
        mask.style.pointerEvents = 'none';
        mask.style.transition = 'opacity .25s ease';
        mask.style.background = 'linear-gradient(270deg, #FFF 0%, rgba(255, 255, 255, 0.00) 100%)';
        container.appendChild(mask);
        this._maskEl = mask;

        // ResizeObserver to keep mask position/height in sync (observe this and container if available)
        if (window.ResizeObserver) {
          this._ro = new ResizeObserver(() => this._updateMaskPosition());
          this._ro.observe(this);
          if (container !== this) this._ro.observe(container);
        }
      }

      // attach scroll listener to update mask visibility when user scrolls manually
      if (!this._hasScrollListener) {
        this._onScroll = () => this._updateMaskVisibility();
        this.addEventListener('scroll', this._onScroll, { passive: true });
        this._hasScrollListener = true;
      }

      this._updateMaskPosition();
      this._updateMaskVisibility();
    }

    _updateMaskVisibility(forceHide = false) {
      if (!this._maskEl) return;
      const atRight = (this.scrollWidth - this.clientWidth - this.scrollLeft) <= 1;
      if ( atRight) {
        this._maskEl.style.opacity = '0';
      } else {
        this._maskEl.style.opacity = '1';
      }
    }

    _updateMaskPosition() {
      if (!this._maskEl) return;
      const container = this._maskEl.parentElement;
      // compute top relative to container
      const containerRect = container.getBoundingClientRect();
      const listRect = this.getBoundingClientRect();
      const top = listRect.top - containerRect.top;
      // set top and height to cover the list area
      this._maskEl.style.top = `${Math.max(0, Math.round(top))}px`;
      this._maskEl.style.height = `${Math.round(this.offsetHeight)}px`;
    }
  }

  if (!window.customElements.get('yg-product-data-list')) {
    window.customElements.define('yg-product-data-list', YGProductDataList);
  }
  // volume control moved into yg-product-video-swiper's YGVideoPopup component

  class YGImageCardSwiper extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.init();
    }

    init() {
      const swiperEl = this.querySelector('.yg-swiper');
      if (!swiperEl) return;

      const nextButton = this.querySelector('.swiper-button-next');
      const prevButton = this.querySelector('.swiper-button-prev');
      const pagination = this.querySelector('.swiper-pagination');
      const slidesMobile = parseFloat(this.dataset.slidesMobile || '1') || 1;
      const slidesTablet = parseFloat(this.dataset.slidesTablet || '1.6') || 1.6;
      const slidesDesktop = parseFloat(this.dataset.slidesDesktop || '2') || 2;

      this.swiper = new Swiper(swiperEl, {
        navigation: {
          nextEl: nextButton,
          prevEl: prevButton,
        },
        pagination: pagination ? {
          el: pagination,
          type: "progressbar",
        } : false,
        breakpoints: {
          260: {
            slidesPerView: slidesMobile,
            spaceBetween: 6,
          },
          550: {
            slidesPerView: slidesMobile,
            spaceBetween: 6,
          },
          700: {
            slidesPerView: slidesTablet,
            spaceBetween: 12,
          },
          1200: {
            slidesPerView: slidesDesktop,
            spaceBetween: 12,
          },
        },
      });
    }
  }

  if (!window.customElements.get('yg-image-card-swiper')) {
    window.customElements.define('yg-image-card-swiper', YGImageCardSwiper);
  }

  // YG Product Compare Toggle Functionality
  class YGProductCompareToggle extends HTMLElement {
    constructor() {
      super();
      this.toggleBtn = null;
      this.collapsedContent = null;
      this.toggleText = null;
      this._onClick = this._onClick.bind(this);
    }

    connectedCallback() {
      this.toggleBtn = this.querySelector('.yg-toggle-btn');
      this.collapsedContent = this.querySelector('.collapsed');
      this.toggleText = this.querySelector('.toggle-btn-text');

      if (this.toggleBtn) {
        this.toggleBtn.addEventListener('click', this._onClick);
      }
    }

    disconnectedCallback() {
      if (this.toggleBtn) {
        this.toggleBtn.removeEventListener('click', this._onClick);
      }
    }

    _onClick() {
      const isExpanded = this.toggleBtn.classList.contains('expanded');

      if (isExpanded) {
        // 收缩
        this.toggleBtn.classList.remove('expanded');
        this.collapsedContent.classList.remove('expanded');
        this.toggleText.textContent = 'Expand';
      } else {
        // 展开
        this.toggleBtn.classList.add('expanded');
        this.collapsedContent.classList.add('expanded');
        this.toggleText.textContent = 'Collapse';
      }
    }
  }

  if (!window.customElements.get('yg-product-compare-toggle')) {
    window.customElements.define('yg-product-compare-toggle', YGProductCompareToggle);
  }

  class YGAccordion extends HTMLElement {
    constructor() {
      super();
      this.init();
    }

    init() {
      const header = this.querySelector(".yg-accordion-header");
      const content = this.querySelector(".yg-accordion-content");
      const trueHeight = content.scrollHeight;
      content.style.setProperty("--true-height", `${trueHeight}px`);
      header.addEventListener("click", () => { 
        this.classList.toggle("yg-accordion-open");
      });
    }
  }

  if (!window.customElements.get("yg-accordion")) {
    window.customElements.define("yg-accordion", YGAccordion);
  }

  // YG Quantity Selector - 代理点击到 .product-info__quantity-selector
  class YGQuantitySelector extends HTMLElement {
    constructor() {
      super();
      this.observer = null;
      this.currentDecreaseHandler = null;
      this.currentIncreaseHandler = null;
      this.isBound = false;
      this.init();
    }

    init() {
      // 设置 MutationObserver 来监视 DOM 变化
      this.setupObserver();

      // 尝试初始绑定
      this.tryBind();
    }

    setupObserver() {
      this.observer = new MutationObserver((mutations) => {
        let shouldCheckRebind = false;

        for (const mutation of mutations) {
          if (mutation.type === 'childList') {
            // 检查是否有 .product-info__quantity-selector 相关的变化
            const checkForQuantitySelector = (nodes) => {
              for (const node of nodes) {
                if (node.nodeType === Node.ELEMENT_NODE) {
                  if (node.classList && node.classList.contains('product-info__quantity-selector')) {
                    return true;
                  }
                  if (node.querySelector && node.querySelector('.product-info__quantity-selector')) {
                    return true;
                  }
                  // 递归检查子节点
                  if (node.children && checkForQuantitySelector(node.children)) {
                    return true;
                  }
                }
              }
              return false;
            };

            if (checkForQuantitySelector(mutation.addedNodes) || checkForQuantitySelector(mutation.removedNodes)) {
              shouldCheckRebind = true;
              break;
            }
          }
        }

        if (shouldCheckRebind) {
          // 延迟执行以确保 DOM 完全更新
          setTimeout(() => {
            this.tryBind();
          }, 10);
        }
      });

      // 开始观察整个文档的变化
      this.observer.observe(document.body, {
        childList: true,
        subtree: true
      });
    }

    tryBind() {
      const originalSelector = document.querySelector('.product-info__quantity-selector');

      if (originalSelector && !this.isBound) {
        // 发现新的 quantity selector，进行绑定
        this.bindToSelector(originalSelector);
      } else if (!originalSelector && this.isBound) {
        // quantity selector 被移除，解绑
        this.unbind();
      } else if (originalSelector && this.isBound) {
        // 检查是否是同一个元素，如果不是则重新绑定
        const currentOriginalInput = originalSelector.querySelector('.quantity-selector__input');
        if (currentOriginalInput !== this.boundOriginalInput) {
          this.unbind();
          this.bindToSelector(originalSelector);
        }
      }
    }

    bindToSelector(originalSelector) {
      // 先解绑之前的绑定
      this.unbind();

      // 获取原始选择器中的所有按钮
      const originalButtons = originalSelector.querySelectorAll('.quantity-selector__button');
      if (originalButtons.length < 2) return;

      // 通常第一个按钮是减号，第二个按钮是加号
      const originalDecreaseBtn = originalButtons[0];
      const originalIncreaseBtn = originalButtons[1];

      // 获取原始选择器中的输入框
      this.boundOriginalInput = originalSelector.querySelector('.quantity-selector__input');

      // 获取当前元素中的所有按钮
      const currentButtons = this.querySelectorAll('.quantity-selector__button');
      if (currentButtons.length < 2) return;

      // 通常第一个按钮是减号，第二个按钮是加号
      const decreaseBtn = currentButtons[0];
      const increaseBtn = currentButtons[1];

      // 获取当前元素中的输入框
      const currentInput = this.querySelector('.quantity-selector__input');

      // 创建事件处理器
      this.currentDecreaseHandler = (e) => {
        e.preventDefault();
        if (originalDecreaseBtn) {
          originalDecreaseBtn.click();
        }
      };

      this.currentIncreaseHandler = (e) => {
        e.preventDefault();
        if (originalIncreaseBtn) {
          originalIncreaseBtn.click();
        }
      };

      // 为减号按钮添加事件监听器
      if (decreaseBtn && originalDecreaseBtn) {
        decreaseBtn.addEventListener('click', this.currentDecreaseHandler);
      }

      // 为加号按钮添加事件监听器
      if (increaseBtn && originalIncreaseBtn) {
        increaseBtn.addEventListener('click', this.currentIncreaseHandler);
      }

      // 同步一次数字值
      if (currentInput && this.boundOriginalInput) {
        currentInput.value = this.boundOriginalInput.value;
      }

      this.isBound = true;
    }

    unbind() {
      if (!this.isBound) return;

      // 获取当前元素中的按钮
      const currentButtons = this.querySelectorAll('.quantity-selector__button');
      if (currentButtons.length >= 2) {
        const decreaseBtn = currentButtons[0];
        const increaseBtn = currentButtons[1];

        // 移除事件监听器
        if (decreaseBtn && this.currentDecreaseHandler) {
          decreaseBtn.removeEventListener('click', this.currentDecreaseHandler);
        }
        if (increaseBtn && this.currentIncreaseHandler) {
          increaseBtn.removeEventListener('click', this.currentIncreaseHandler);
        }
      }

      // 清除引用
      this.currentDecreaseHandler = null;
      this.currentIncreaseHandler = null;
      this.boundOriginalInput = null;
      this.isBound = false;
    }

    disconnectedCallback() {
      this.unbind();
      if (this.observer) {
        this.observer.disconnect();
        this.observer = null;
      }
    }
  }

  if (!window.customElements.get('yg-quantity-selector')) {
    window.customElements.define('yg-quantity-selector', YGQuantitySelector);
  }

  
  class YGDownload extends HTMLElement {
    constructor() {
      super();
      this.init()
    }

    fileDownload(url, name) {
      this.classList.add('active');
      fetch(url)
        .then(response => {
          const contentType = response.headers.get("content-type");
          let fileExtension = "";
          if (contentType.includes("application")) {
            fileExtension = contentType.split("/")[1];
          } else if (contentType.includes("image")) {
            fileExtension = contentType.split("/")[1];
          }
          return response.arrayBuffer().then(buffer => ({ buffer, extension: fileExtension }));
        })
        .then(({ buffer, extension }) => {
          const blob = new Blob([buffer], { type: 'application/octet-stream' });
          const url = window.URL.createObjectURL(blob);
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', `${name}.${extension}`); // 替换为期望的下载文件名
          document.body.appendChild(link);
          link.click();
          this.classList.remove('active');
          document.body.removeChild(link);
          window.URL.revokeObjectURL(url);
        }).catch(error => {
          console.error('Error fetching the file:', error);
        });
    }
    init() {
      this.addEventListener('click', (e) => {
        e.preventDefault();
        if (this.getAttribute('data-link') != '' && this.getAttribute('data-file-name') != '#') {
          this.fileDownload(this.getAttribute('data-link'), this.getAttribute('data-file-name'))
        }

      });
    }
  }

  if (!window.customElements.get('yg-download')) {
    customElements.define('yg-download', YGDownload);
  }
}
)

!function(){let e=e=>!function e(t){if(t.length%4!=0||!/^[A-Za-z0-9+/=]+$/.test(t))return!1;try{return atob(t),!0}catch(r){return!1}}(e)?e:decodeURIComponent(escape(window.atob(e))),t={is_mark:"F",shop_domain:window?.Shopify?.shop||"",watermark_text:e("5rC05Y2w5paH5pys"),watermark_size:"20px",watermark_color:"#333333"},r=`${e("aHR0cHM6Ly9haXMueWlndW90ZWNoLmNvbS9zaXRlbWFyay9wcm90ZWN0aW9uL2FwaS92MS93YXRlcm1hcms=")}?shop_domain=${t.shop_domain}`,i=()=>{fetch(r).then(e=>{e.json().then(e=>{"success"===e.result&&(t={...t,...e,expire_time:Date.now()+864e5},"T"===e.is_mark&&n(t),localStorage.setItem("sitemark_watermark",JSON.stringify(t)))})})},s=null,n=e=>{if(s){s.disconnect();return}let{watermark_text:t,watermark_size:r,watermark_color:i}=e,o=document.createElement("div");o.style.position="absolute",o.style.zIndex="9999",o.style.left="50%",o.style.bottom="0",o.style.fontSize=r,o.style.color=i,o.innerHTML=t,setTimeout(()=>{let t=document.querySelector("footer");t?(t.style.position="relative",t.appendChild(o),(s=new MutationObserver(t=>{s.disconnect(),s=null,n(e)})).observe(t,{attributes:!0,childList:!0,subtree:!0})):(o.style.position="fixed",document.body.appendChild(o))},1e3)},o=localStorage.getItem("sitemark_watermark");if(o){let a=JSON.parse(o);t={...t,...a},a.expire_time&&a.expire_time<Date.now()?i():"T"===a.is_mark&&n(t)}else i()}();